import React, { ReactNode, useMemo } from 'react';
import { VStack } from '@televet/kibble-ui';
import FormHeader from './FormHeader';
import { FormSubHeader } from './FormSubHeader';
import { useWidgetStore } from 'state/useWidgetStore';

export function FormContainer({ children }: { children: ReactNode }): JSX.Element {
  const {
    clinicPetParent,
    isPetPortal,
    authentication: { isPetParentInactive },
  } = useWidgetStore((state) => state);

  // We should not show the sub header if:
  // - The pet parent doesn't have a first or last name
  // - The pet parent is inactive
  // - The widget is being rendered in the pet portal
  const shouldHideSubheader = useMemo(
    () => !clinicPetParent?.firstName || !clinicPetParent?.lastName || isPetParentInactive || isPetPortal,
    [clinicPetParent?.firstName, clinicPetParent?.lastName, isPetParentInactive, isPetPortal],
  );

  return (
    <VStack className="Widget__FormContainer" align="flex-start" w="100%" spacing={0} h="100%" overflow="auto">
      {!isPetPortal && <FormHeader />}
      {!shouldHideSubheader && <FormSubHeader />}
      {children}
    </VStack>
  );
}
